export enum RequestStatus {
  INITIAL = 'initial',
  SUCCESS = 'success',
  FAILURE = 'failure',
}
